export default "__VITE_ASSET__19ad2039__"